import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

type ItemProps = {
  isSelected?: boolean;
};

export const Item = styled(Flex).attrs({
  width: '100%',
  align: 'stretch',
})<ItemProps>`
  flex: 1;
  overflow: hidden;
  justify-content: center;
  border: 1px solid #dcdcdc;
  border-radius: 5px;

  &:hover {
    border: 1px solid ${props => props.theme.colors.primary};
    box-shadow: 0px 2px 7px 0px #00000026;
  }

  ${props => props.isSelected && `
    border: 1px solid ${props.theme.colors.primary};
    box-shadow: 0px 2px 7px 0px #00000026;

    .ItemTitle,
    .ItemPrice {
      color: ${props.theme.colors.primary};
    }
  `}
`;

export const ItemImage = styled(Flex).attrs({
  flex: '0 0 334px',
})`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left center;
  img {
    max-width: 100%;
  }
`;

export const ItemData = styled(Flex).attrs({
  grow: 1,
  spacing: 30,
  justify: 'space-between',
  padding: '15px 30px',
})`
  border-left: none;
`;

export const ItemTitle = styled.span`
  color: #757575;
  font-size: 1.6em;
  font-weight: 600;
  line-height: 44px;

  span {
    color: #757575;
    font-size: 0.7em;
    font-weight: 400;
    margin-left: 20px;
  }

  svg {
    position: relative;
    top: 5px;
    left: 10px;
  }
`;

export const ItemPrice = styled(Flex).attrs({
  align: 'baseline',
  spacing: 5,
})`
  color: #555555;
  margin-top: -2px;

  & > b {
    font-size: 2.2em;
    font-weight: 600;
  }
`;
